import { images } from '../images';

export const getQuestion = () => new Promise((resolve, reject) => {
  setTimeout(() => {
    if (images) {
      resolve(images);
    } else {
      reject('Loading question error!');
    }
  }, 500);
});
